import CellHOC from '@platform/react/hoc/pubsub/cell'

export default CellHOC
